/**
 * oddit-section-ingredients
 * - Auto-rotating ingredient card carousel
 * - Pause on hover
 * - Dynamic duration based on card count
 * - Theme editor lifecycle support
 */
(function () {
  'use strict';

  function initSection(sectionEl) {
    if (!sectionEl) return null;

    var section = sectionEl.querySelector('.oddit-section-ingredients') || sectionEl;
    if (!section.classList.contains('oddit-section-ingredients')) return null;

    var track = section.querySelector('[data-ingredient-carousel]');
    if (!track) return null;

    var originalCount = track.querySelectorAll(
      '.oddit-section-ingredients__card:not(.oddit-section-ingredients__card--duplicate)'
    ).length;
    var speedPerCard = (parseInt(track.getAttribute('data-speed'), 10) || 3) * 1000;

    if (originalCount > 0) {
      var duration = originalCount * speedPerCard;
      track.style.setProperty('--carousel-duration', duration + 'ms');
    }

    return {
      destroy: function () {
        track.style.removeProperty('--carousel-duration');
      }
    };
  }

  /* -----------------------------------------------------------------------
     Initialize on page load
     ----------------------------------------------------------------------- */
  var instances = new Map();

  function initAll() {
    document.querySelectorAll('.oddit-section-ingredients').forEach(function (el) {
      var sectionWrapper = el.closest('.shopify-section') || el;
      if (!instances.has(sectionWrapper)) {
        var instance = initSection(sectionWrapper);
        if (instance) instances.set(sectionWrapper, instance);
      }
    });
  }

  initAll();

  /* -----------------------------------------------------------------------
     Theme editor lifecycle
     ----------------------------------------------------------------------- */
  document.addEventListener('shopify:section:load', function (e) {
    var instance = initSection(e.target);
    if (instance) instances.set(e.target, instance);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var instance = instances.get(e.target);
    if (instance) {
      instance.destroy();
      instances.delete(e.target);
    }
  });

  document.addEventListener('shopify:section:select', function (e) {
    var existing = instances.get(e.target);
    if (existing) existing.destroy();
    var instance = initSection(e.target);
    if (instance) instances.set(e.target, instance);
  });
})();
